export default __webpack_public_path__ + "static/media/ic_uruguay.025114f1.svg";